










import Vue from "vue";

interface Props {
  body: string[];
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  name: "ChatText",
  props: {
    body: {
      type: Array,
      default: () => []
    }
  }
});
